import React, { useState } from "react";
import styled from "styled-components";
import imgCross from '../../../../assets/images/cross.svg';
import imgBus from '../../../../assets/images/busCircle.svg';
import imgTram from '../../../../assets/images/Tram_Icon_Transparent.svg';
import { closeNavTab } from "../../../../shared/components/NavTab/fuctionsControl";
import RouteList from "./components/RouteList";
import LoaderCircle from "../loaders/LoaderCircle";
import useBSI from "./useBSI";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/redux/store";
import DatePicker from "../../../../shared/components/Inputs/DatePicker";
import useBusstaitions from "../../hooks/useBusstaitions";
import { setClickedStaitionByPlacemark, setRoadmap, setRoadmaps, setTransports, setVehTransports } from "../../store/mapScreenSlce";

const BusStationInfo = () => {
    const { mapMode, roadmap } = useSelector((state: RootState) => state.mapScreen);
    const { busStation, roadmaps, loading } = useBSI();
    const { selectBusStaition } = useBusstaitions();
    const [showFullName, setShowFullName] = useState(false);
    const [date, setDate] = useState();
    const dispatch = useDispatch();

    const handleToggle = () => setShowFullName((prev) => !prev);

    function handleCloseNav() {
        closeNavTab();
        setShowFullName(false);
        selectBusStaition(undefined, false);
        dispatch(setRoadmap(undefined));

        if (mapMode === 'busStops') {
            dispatch(setRoadmaps([]));
            dispatch(setVehTransports([]));
        }

        dispatch(setClickedStaitionByPlacemark(undefined));
    }

    const extractMainText = (name) => {
        if (!name) return "";
        const index = name.indexOf("в сторону");
        return index !== -1 ? name.substring(0, index).trim() : name;
    };

    const extractRemainingText = (name) => {
        if (!name) return "";
        const index = name.indexOf("в сторону");
        return index !== -1 ? name.substring(index).trim() : "";
    };

    const mainText = extractMainText(busStation?.name);
    const remainingText = extractRemainingText(busStation?.name);

    return (
        <Container>
            {/* <div style={{ margin: '10px auto 0px 10px' }}>
                <DatePicker onDateChange={setDate} />
            </div> */}
            <ContainerInfo>
                <TopContainer>
                    <Image src={imgCross} onClick={handleCloseNav} />
                    <Title>
                        Табло остановки {mainText} {showFullName && remainingText}
                    </Title>
                    {!showFullName && remainingText && (
                        <ButtonDirection
                            onClick={handleToggle}
                            isTram={busStation?.transport_type === 'ТРАМВАЙ'}
                        >
                            Показать направления
                        </ButtonDirection>
                    )}
                    <Image src={busStation?.transport_type !== 'ТРАМВАЙ' ? imgBus : imgTram} />
                </TopContainer>
                {showFullName && (
                    <ButtonWrapper>
                        <ButtonDirection
                            onClick={handleToggle}
                            isTram={busStation?.transport_type === 'ТРАМВАЙ'}
                        >
                            Скрыть направления
                        </ButtonDirection>
                    </ButtonWrapper>
                )}
            </ContainerInfo>
            <RouteList isTram={busStation?.transport_type === 'ТРАМВАЙ'} />
        </Container>
    );
};

export default BusStationInfo;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    align-items: center;
`;

const ContainerInfo = styled.div`
    width: 100%;
    border-bottom: 1px solid #9DA3B5;
    display: flex;
    flex-direction: column;
`;

const TopContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;  
    align-items: center;
    padding: 20px;
    width: calc(100% - 40px);  
    // border-bottom: 1px solid #9DA3B5;
`;

const Title = styled.p`
    font-size: 16px;
    font-weight: bold;
    margin: 0 15px;
    text-align: right;
`;

const Image = styled.img`
    width: 35px;
    height: 35px;
`;

const ButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
`;

const ButtonDirection = styled.button<{ isTram: boolean }>`
    font-size: 15px;
    background-color: ${({ isTram }) => (isTram ? '#FF4D4D' : '#24CD73')};
    color: white;
    padding: 5px 12px;
    border-radius: 15px;
    cursor: pointer;
    margin-right: 10px;
    transition: background-color 0.3s;
`;